export default {
  emailLogs: [],
}
